import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogTitle, Divider } from "@mui/material"
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import { useMutation } from '@tanstack/react-query'
import PaymentAPI from 'api/faber/PaymentAPI'
import OrbitSession from 'hooks/useCookies'

export default function DeletePaymentMethodDialog({
    deletePaymentMethodDialogOpen,
    handleDeletePaymentMethodDialogClose,
    userID,
    isExternal
}: PaymentMethodDialog) {
    const faberToken = OrbitSession.get('faberToken')
    const {
        mutate: sendDeletePaymentMethod,
        isLoading: isDeletePaymentMethodLoading
    } = useMutation(isExternal ? PaymentAPI.deleteExternalUserPaymentMethods : PaymentAPI.deleteUserPaymentMethods, {
        onSettled: () => {
            handleDeletePaymentMethodDialogClose()
        },
        onSuccess: () => {
            toast.success("Successfully deleted user payment methods")
        },
        onError: () => {
            toast.error("Failed and did not delete user payment methods")
        }
    })

    const deletePaymentMethod = () => {
        sendDeletePaymentMethod({
            faberToken: faberToken,
            userID: userID
        })
    }

    return (
        <Dialog
            open={deletePaymentMethodDialogOpen}
            onClose={handleDeletePaymentMethodDialogClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >

        <DialogTitle id='alert-dialog-title' sx={{ fontSize: '1.2em' }}>
            Delete Payment Method
        </DialogTitle>

        <Divider/>

        <DialogContent>
            <DialogContentText id='alert-dialog-description'>
                This will remove all payment methods for this user.
            </DialogContentText>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleDeletePaymentMethodDialogClose}>Cancel</Button>
            <LoadingButton
                variant='contained'
                onClick={deletePaymentMethod}
                loading={isDeletePaymentMethodLoading}
                autoFocus
                >
                Delete Payment
            </LoadingButton>
        </DialogActions>

        </Dialog>
    )
}

interface PaymentMethodDialog {
    deletePaymentMethodDialogOpen: boolean
    handleDeletePaymentMethodDialogClose: () => void
    userID: string
    isExternal: boolean
}